import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';
import { ChartModule } from 'primeng/chart';

import { CoreModule } from 'src/app/core/core.module';
import { UsersActivityRoutingModule } from './users-activity-routing.module';
import { UsersActivityListComponent } from './users-activity-list/users-activity-list.component';

@NgModule({ declarations: [
        UsersActivityListComponent
    ], imports: [CoreModule,
        UsersActivityRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        DropdownModule,
        MultiSelectModule,
        CalendarModule,
        TooltipModule,
        ChartModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class UsersActivityModule { }
